import React, { Component } from 'react';

import './biometry.scss';

import { BiometryAPI, BiometryStatus } from '@philips-emr/tws-components-api';
import { ButtonTheme, Expression } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { eventListener, expression, oneOf } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames, enumValues, isEnumValid, isFunction } from '@philips-emr/tws-utils';

import { Button, Link } from '..';

@AwesomeComponent({ type: ComponentType.DATA_ENTRY, api: BiometryAPI })
class Biometry extends Component {
  static propTypes = {
    cancelExpression: expression,
    captureExpression: expression,
    notFoundExpression: expression,
    onSubmit: eventListener,
    onCancel: eventListener,
    removeExpression: expression,
    retryExpression: expression,
    status: oneOf(enumValues(BiometryStatus)),
    touchExpression: expression,
  };

  static defaultProps = {
    cancelExpression: Expression.CANCEL,
    captureExpression: Expression.CAPTURE_FINGERPRINT,
    notFoundExpression: Expression.USER_NOT_FOUND,
    removeExpression: Expression.REMOVE,
    retryExpression: Expression.RETRY,
    status: BiometryStatus.DEFAULT,
    touchExpression: Expression.DETECT_TOUCH,
  };

  onButtonClick = () => {
    const { onSubmit, status  } = this.props;
    isFunction(onSubmit) && onSubmit({ record: status });
  };

  onLinkClick = () => {
    const { onCancel, status } = this.props;

    isFunction(onCancel) && onCancel({ value: status });
  };

  getButtonText() {
    const { status } = this.props;

    const texts = {
      [BiometryStatus.DEFAULT]: msg(this.props.captureExpression),
      [BiometryStatus.FAILED]: msg(this.props.retryExpression),
      [BiometryStatus.SUCCESS]: msg(this.props.removeExpression),
      [BiometryStatus.WAITING]: msg(this.props.touchExpression),
    };

    return texts[status] || null;
  }

  getHelpText() {
    const { status } = this.props;

    return {
      [BiometryStatus.FAILED]: msg(this.props.notFoundExpression),
    }[status];
  }

  getClassName() {
    const { status } = this.props;

    return classNames({
      'c-biometry': true,
      [`c-biometry--${status}`]: isEnumValid(BiometryStatus, status),
    });
  }

  renderFingerprint() {
    return <div className="c-biometry__fingerprint" x-contrast="cl" />;
  }

  renderButton() {
    const { status } = this.props;
    const text = this.getButtonText();

    if (!text) {
      return null;
    }

    const props = {
      background: status === BiometryStatus.WAITING ? '#9e9e9e' : null,
      bold: true,
      className: 'c-biometry__custom-button',
      enabled: status !== BiometryStatus.WAITING,
      onClick: this.onButtonClick,
      theme: status === BiometryStatus.WAITING ? ButtonTheme.DEFAULT : ButtonTheme.OUTLINE,
    };

    return (
      <div className="c-biometry__button">
        <Button {...props}>{text}</Button>
      </div>
    );
  }

  renderLink() {
    const { status, cancelExpression } = this.props;

    if (status !== BiometryStatus.WAITING) {
      return null;
    }

    return (
      <Link className="c-biometry__custom-link" onClick={this.onLinkClick}>
        {msg(cancelExpression)}
      </Link>
    );
  }

  renderText() {
    const { notFoundExpression } = this.props;

    return <span>{msg(notFoundExpression)}</span>;
  }

  renderBottom() {
    const { status } = this.props;

    let content = null;
    if (status === BiometryStatus.WAITING) {
      content = this.renderLink();
    }

    if (status === BiometryStatus.FAILED) {
      content = this.renderText();
    }

    if (!content) {
      return null;
    }

    return <div className="c-biometry__help-text">{content}</div>;
  }

  render() {
    return (
      <div className={this.getClassName()}>
        {this.renderFingerprint()}
        {this.renderButton()}
        {this.renderBottom()}
      </div>
    );
  }
}

export default Biometry;
